<template>
  <div>
    <h1>Home Page</h1>
    <router-link to="/lottery">去抽奖</router-link><br />
    <router-link to="/createLottery">创建抽奖</router-link>
    <router-link to="/authSite">三站认证</router-link>
  </div>
</template>

<script setup>
// 这个页面暂时没逻辑
</script>
